module.exports = __webpack_public_path__ + "img/stripe-logo-slate.399d8a7c.png";